import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ViewImageComponent } from '../component/view-image/view-image.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from './data.service';
import { forkJoin } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  inProgressSearch: Object;

  constructor(
    private toastr: ToastrService,
    private modalService: NgbModal,
    private router: Router,
    private _ds: DataService) { }

  
  navigate(path: string) {
    const vm = this;
    vm.router.navigate([path]);
  }

  success(message: string) {
    const vm = this;
    vm.toastr.success(message);
  }

  error(message: string) {
    const vm = this;
    vm.toastr.error(message);
  }

  warning(message: string) {
    const vm = this;
    vm.toastr.warning(message);
  }

  getServerDate(cb: any) {
    const vm = this;
    vm._ds.getData('/generic/getDate').subscribe(res => {
      if (res && !res.error && res.data && res.data.date) {
        cb(res.data.date);
      } else {
        vm.error('Unable to get date, please contact admin');
        cb(false);
      }
    });
  }

  readDoc(fileInput: any, cb: any) {
    const vm = this;
    if (fileInput.target.files && fileInput.target.files[0]) {
      const image = fileInput.target.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const file = e.target.result;
        if (((file.includes('application/pdf')) || file.includes('image/png') || file.includes('image/jpeg'))) {
          cb(e.target.result);
        } else {
          vm.error('Only PDF, jpeg, png formats allowed');
          cb(false);
        }
      };
      reader.readAsDataURL(image);
    } else {
      cb(false);
    }
  }

  uploadDocAPICall(image: string, cb: any) {
    const vm = this;
    const req = { file: image }
    vm._ds.postData('/document/upload', req).subscribe(res => {
      if (res && !res.error) {
        cb(res.data);
      } else {
        cb(false);
      }
    });
  }

  fetchDoc(mongoIds: any) {
    return new Promise((resolve, reject) => {
      const vm = this;
      const apiArray = [];
      if (mongoIds && Array.isArray(mongoIds) && mongoIds.length > 0) {
        mongoIds.forEach((id: string) => {
          apiArray.push(vm._ds.getData('/document/fetch/' + id));
        });
      } else {
        apiArray.push(vm._ds.getData('/document/fetch/' + mongoIds));
      }

      forkJoin(apiArray).subscribe(res => {
        const docs = [];
        res.forEach(d => {
          if (d && !d['error'] && d['data']) {
            docs.push(d['data']);
          }
        });
        resolve(docs[0]);
      });
    });
  }

  fetchAndViewDoc(mongoIds: any): void {
    const vm = this;
    const apiArray = [];
    if (mongoIds && Array.isArray(mongoIds) && mongoIds.length > 0) {
      mongoIds.forEach((id: string) => {
        apiArray.push(vm._ds.getData('/document/fetch/' + id));
      });
    } else {
      apiArray.push(vm._ds.getData('/document/fetch/' + mongoIds));
    }

    forkJoin(apiArray).subscribe(res => {
      const docs = [];
      res.forEach(d => {
        if (d && !d['error'] && d['data']) {
          docs.push(d['data']);
        }
      });
      const type = docs[0].split(';')[0].split('/')[0];
      if (type.indexOf('image') >= 0) {
        const modalRef = vm.modalService.open(ViewImageComponent, { windowClass: 'fullScreenModel', backdrop: 'static', size: 'md' });
        modalRef.componentInstance.docs = docs;
      } else {
        const pdfWindow = window.open("")
        pdfWindow.document.write("<iframe width='100%' height='100%' src='" + encodeURI(docs[0]) + "'></iframe>")
      }
    });
  }

  deleteDoc(mongoIds: any, cb: any) {
    const vm = this;
    const apiArray = [];
    if (mongoIds && Array.isArray(mongoIds) && mongoIds.length > 0) {
      mongoIds.forEach((id: string) => {
        apiArray.push(vm._ds.getDataNoToken('/document/delete/' + id));
      });
    } else {
      apiArray.push(vm._ds.getDataNoToken('/document/delete/' + mongoIds));
    }

    forkJoin(apiArray).subscribe(res => {
      cb(true);
    });
  }

  getExcelPath(url, res) {
    if (res && res.filter && res.filter.filters) {
        res.filter.filters.forEach(filter => {
          if (filter['field'] && filter['search']) {
            url += '&' + filter['field'] + '_like' + '=' + filter['search'];
          }
        });
    }
    return url;
  }

  setSearch(flag: boolean, searchText: any) {
    const vm = this;
    vm.inProgressSearch = vm.processSearchString(searchText);
    console.log(vm.inProgressSearch);
  }

  processSearchString(searchText: any) {
    const res = {};
    const filters = [];
    // console.log(searchText);
    if (searchText && searchText.filter && searchText.filter.filters && Array.isArray(searchText.filter.filters)) {
      searchText.filter.filters.forEach(fil => {
        if (fil && fil['field'] && fil['search']) {
          const sear = {};
          sear['field'] = fil['field'];
          sear['search'] = fil['search'];
          filters.push(sear);
        }
      });
    }
    res['filters'] = filters;
    const paging = { 'page': 1, 'perPage': 10 };
    if (searchText && searchText.paging && searchText.paging.page && searchText.paging.perPage) {
      paging.page = searchText.paging.page;
      paging.perPage = searchText.paging.perPage;
    }
    res['paging'] = paging;
    return res;
  }

  getSearch(flag: boolean) {
    const vm = this;
    return vm.inProgressSearch;
  }

}
